export default "__VITE_ASSET__C8Ignh8k__"